// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__VDdKy","block":"style_block__3ZML1","blockCenter":"style_blockCenter__1_49l","blockBottom":"style_blockBottom__14_y8"};